module.exports = __webpack_public_path__ + "img/girl.1cc90c1b.png";